// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * Monitor a node by polling it (repeated Read service calls) every
 * `interval_ms` milliseconds.
 */
export class PollMode implements flatbuffers.IUnpackableObject<PollModeT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): PollMode {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsPollMode(bb: flatbuffers.ByteBuffer, obj?: PollMode): PollMode {
    return (obj || new PollMode()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsPollMode(bb: flatbuffers.ByteBuffer, obj?: PollMode): PollMode {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new PollMode()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  intervalMs(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 1000n;
  }

  static startPollMode(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addIntervalMs(builder: flatbuffers.Builder, intervalMs: bigint) {
    builder.addFieldInt64(0, intervalMs, 1000n);
  }

  static endPollMode(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createPollMode(builder: flatbuffers.Builder, intervalMs: bigint): flatbuffers.Offset {
    PollMode.startPollMode(builder);
    PollMode.addIntervalMs(builder, intervalMs);
    return PollMode.endPollMode(builder);
  }

  unpack(): PollModeT {
    return new PollModeT(this.intervalMs());
  }

  unpackTo(_o: PollModeT): void {
    _o.intervalMs = this.intervalMs();
  }

  unpackFields(...fields: string[]): PollModeT {
    const t = new PollModeT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("interval_ms")) {
      t.intervalMs = this.intervalMs();
    }
    return t;
  }
}

export class PollModeT implements flatbuffers.IGeneratedObject {
  constructor(public intervalMs: bigint = 1000n) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return PollMode.createPollMode(builder, this.intervalMs);
  }

  clone(): PollModeT {
    const obj = new PollModeT();
    obj.intervalMs = this.intervalMs;
    return obj;
  }

  equals(other: PollModeT): boolean {
    if (this.intervalMs !== other.intervalMs) return false;
    return true;
  }
}

export function verifyPollMode(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
  } finally {
    verifier.popDepth();
  }
}
